module.exports = __webpack_public_path__ + "public/StoreIcon/preparationTim.svg?dc63d9db";